import React from 'react';
import { Table } from 'reactstrap';
import { MomentDateFormat } from '../MomentDateFormat';
import { fromUtcToLocalMoment } from '../utilities/DateHelpers';

export class ImportTrackersDisplay extends React.Component {
    getImportSystemName = (importTracker) => {
        const { importSystems } = this.props;

        const importSystem = importSystems.find(
            (ims) => importTracker.importSystemId == ims.id
        );

        return importSystem?.name;
    };

    getImportStatusName = (importTracker) => {
        const { importTrackerStatuses } = this.props;

        const importStatus = importTrackerStatuses.find(
            (its) => importTracker.importTrackerStatusId == its.id
        );

        return importStatus?.name;
    };

    getStartTime = (importTracker) =>
        fromUtcToLocalMoment(importTracker.startTime).format(
            MomentDateFormat.DateTimeShortAnte
        );

    getEndTime = (importTracker) =>
        importTracker.endTime
            ? fromUtcToLocalMoment(importTracker.endTime).format(
                  MomentDateFormat.DateTimeShortAnte
              )
            : '';

    render() {
        const { importTrackers } = this.props;

        return (
            <Table>
                <thead>
                    <tr>
                        <th>System</th>
                        <th>Status</th>
                        <th>Start Time</th>
                        <th>End Time</th>
                        <th>Error Message</th>
                    </tr>
                </thead>
                <tbody>
                    {importTrackers.map((importTracker) => {
                        const importSystemName =
                            this.getImportSystemName(importTracker);

                        const importStatusName =
                            this.getImportStatusName(importTracker);

                        return (
                            <tr key={importTracker.id}>
                                <td>{importSystemName}</td>
                                <td>{importStatusName}</td>
                                <td>{this.getStartTime(importTracker)}</td>
                                <td>{this.getEndTime(importTracker)}</td>
                                <td className="white-space-pre">
                                    {importTracker.errorMessage}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </Table>
        );
    }
}
